import React, { useEffect, useState } from "react";
import { useAppContext } from "../context/AppContext";
import { hideModal, showModal } from "../utils/modalUtility";
import useAxios from "../utils/useAxios";

const FollowUpRemarkTab = ({ donor_id }) => {
  //   console.log("Donor id", donor_id);
  const [role, setRole] = useState(null);
  const { state } = useAppContext();
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    followUpRemark: "",
  });

  const [followUpRemarkData, setFollowUpRemarkData] = useState([]);

  const axiosAPI = useAxios();

  useEffect(() => {
    setRole(state?.user?.role);
  }, []);

  function handleChange(e) {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (!formData.followUpRemark) {
      window.notifyMessage("Error", "Remark is required", "danger");
      return;
    }

    const payload = {
      user_id: donor_id,
      description: formData.followUpRemark,
    };

    try {
      let response;

      if (isEditMode) {
        // UPDATE
        response = await axiosAPI.put(
          `/api/follow-up-remarks/${currentUserId}`,
          payload
        );

        window.notifyMessage(
          "Success",
          "Follow-up remark updated successfully",
          "success"
        );

        // Optional: local state update
        // setRemarks((prev) =>
        //   prev.map((r) =>
        //     r.id === currentRemarkId
        //       ? { ...r, description: formData.followUpRemark }
        //       : r
        //   )
        // );
      } else {
        // ADD
        response = await axiosAPI.post(
          "/api/donor/add-follow-up-remarks",
          payload
        );

        window.notifyMessage(
          "Success",
          "Follow-up remark added successfully",
          "success"
        );
      }

      // Common actions
      setIsEditMode(false);
      setFormData((prev) => ({ ...prev, followUpRemark: "" }));

      // Optional refresh
      fetchFollowUpRemarkDataById(donor_id);

      // Optional modal close
      hideModal("giftModal");
    } catch (error) {
      if (error.response?.data?.message) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }
  }

  const fetchFollowUpRemarkDataById = async () => {
    try {
      setLoading(true);
      const response = await axiosAPI.get(
        `/api/donor/follow-up-remarks/${donor_id}`
      );
      //   console.log(response.data.data);
      setFollowUpRemarkData(response.data.data); // Assuming backend returns { data: [...] }
      //   setError("");
    } catch (err) {
      console.error("Error fetching follow Data:", err);
      //   setError("Failed to fetch gifts.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (donor_id) {
      fetchFollowUpRemarkDataById();
    }
  }, [donor_id]);

  return (
    <div>
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mb-4">
          {/*  Right Side - Existing Buttons */}
          {role === "admin" && (
            <div className="d-flex gap-2 flex-wrap">
              <button
                type="button"
                className="btn btn-dark btn-round"
                onClick={() => showModal("giftModal")}
              >
                Add Remark
              </button>
            </div>
          )}
        </div>

        {/* Modal */}
        <div
          className="modal fade "
          id="giftModal"
          tabIndex="-1"
          aria-labelledby="giftModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content border">
              <div className="modal-header">
                <h5 className="modal-title" id="giftModalLabel">
                  {isEditMode
                    ? "Edit Follow Up Remark"
                    : "Add Follow Up Remark"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => hideModal("giftModal")}
                ></button>
              </div>
              <div className="modal-body shadow">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="followUpRemark" className="form-label">
                      Follow Up Remark
                    </label>

                    <textarea
                      className="form-control"
                      id="followUpRemark"
                      name="followUpRemark"
                      rows="3"
                      value={formData.followUpRemark}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary btn-round btn-sm"
                  >
                    {isEditMode
                      ? "Update Follow Up Remark"
                      : "Add Follow Up Remark"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Gifts Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-end flex-wrap gap-3">
                {/* Title */}
                <h4 className="card-title mb-0">
                  All follow Up Remarks ({followUpRemarkData?.length})
                </h4>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>Description</th>
                        <th>Date and Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="3" className="text-center">
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-success"
                                role="status"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : followUpRemarkData.length === 0 ? (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      ) : (
                        followUpRemarkData.map((followUpRemarkData, index) => {
                          return (
                            <tr key={followUpRemarkData?.id}>
                              <td>{index + 1}</td>
                              <td>{followUpRemarkData?.description}</td>
                              <td>
                                {new Date(
                                  followUpRemarkData?.created_at + "Z"
                                )?.toLocaleString()}
                              </td>
                              {/* <td>{gifts.contact_id}</td> */}
                              {/* <td>{gifts.gift_id}</td> */}

                              {/* <td>{truncatedMessage}</td> */}
                              {/* <td>{formattedDate}</td> */}
                              {/* <td>
                                {role === "admin" && (
                                  <button
                                    className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                    onClick={() => openEditModal(gifts.id)}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                )}
                                 <button
                                      className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                      onClick={() => handleDelete(gifts.id)}
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button> 
                                {role === "admin" && (
                                      <button
                                        className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                        onClick={() => handleDelete(gifts.id)}
                                      >
                                        <i className="fas fa-trash"></i>
                                      </button>
                                    )}
                              </td> */}
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FollowUpRemarkTab;
